import { render, staticRenderFns } from "./MapLoader.vue?vue&type=template&id=0b0f2656&"
import script from "./MapLoader.vue?vue&type=script&lang=js&"
export * from "./MapLoader.vue?vue&type=script&lang=js&"
import style0 from "./MapLoader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports